module.exports = __webpack_public_path__ + "img/aws_logo.02890739.jpg";